import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  root: {
    marginTop: 0,
    marginBottom: 0,
    '& > div': {
      marginTop: 0,
    },
  },
});

const DropdownFilter = ({ accessor, filters, updateFilterValue }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const handleChange = ({ target }) => {
    updateFilterValue({
      target: { name: accessor, value: target.value },
    });
  };

  return (
    <Select
      className={classes.root}
      fullWidth
      size="small"
      value={filters[accessor]}
      onChange={handleChange}
    >
      {[
        { value: true, label: translateString('Yes') },
        { value: false, label: translateString('No') },
      ].map((item, i) => (
        <MenuItem key={`${item.label}_${i}`} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default DropdownFilter;
